import { useIntl } from 'react-intl';
import { ProjectCategories } from 'components/Dialog/types';
import { SERVICE_BREAK_LABEL } from 'utils/projectCategories';
import { FullReportDay } from './types';
import { TableFooterCell } from './Table.css';

type CategorizedDay = Pick<FullReportDay, 'date'> & {
  projectBasicInfo?: { projectCategory?: ProjectCategories | string | null };
  project?: { projectCategory?: ProjectCategories | string | null };
};

const getCategory = (day: CategorizedDay) =>
  day.projectBasicInfo?.projectCategory ?? day.project?.projectCategory;

// "Service break" is the only absence counter of B2B and civil-contract
// consultants. It counts calendar days, so a day split across entries is
// counted once; legacy DAY_OFF and UNPLANNED_SERVICE_BREAK entries count in
// no category.
export const countServiceBreakDays = (days: CategorizedDay[]) =>
  new Set(
    days
      .filter(
        (day) => getCategory(day) === ProjectCategories.plannedServiceBreak,
      )
      .map(({ date }) => date),
  ).size;

export const ServiceBreakCounterCell = ({
  days,
}: {
  days: CategorizedDay[];
}) => {
  const intl = useIntl();

  return (
    <TableFooterCell $whiteText>
      {`${intl.formatMessage({
        id: SERVICE_BREAK_LABEL,
      })}: ${countServiceBreakDays(days)}`}
    </TableFooterCell>
  );
};

// Backend-provided service break count; null for responses without it.
export const getReportedServiceBreakDays = (data?: {
  serviceBreakDays?: number | null;
}) =>
  data && typeof data.serviceBreakDays === 'number'
    ? data.serviceBreakDays
    : null;
